export const GET_GYM_TV_CHANNELS_REQUEST = 'GET_GYM_TV_CHANNEL_REQUEST';
export const GET_GYM_TV_CHANNELS_SUCCESS = 'GET_GYM_TV_CHANNEL_SUCCESS';
export const GET_GYM_TV_CHANNELS_FAILED = 'GET_GYM_TV_CHANNEL_FAILED';

export const CREATE_GYM_TV_CHANNEL_REQUEST = 'CREATE_GYM_TV_CHANNEL_REQUEST';
export const CREATE_GYM_TV_CHANNEL_SUCCESS = 'CREATE_GYM_TV_CHANNEL_SUCCESS';
export const CREATE_GYM_TV_CHANNEL_FAILED = 'CREATE_GYM_TV_CHANNEL_FAILED';

export const GET_GYM_TV_CHANNEL_BY_ID_REQUEST = 'GET_GYM_TV_CHANNEL_BY_ID_REQUEST';
export const GET_GYM_TV_CHANNEL_BY_ID_SUCCESS = 'GET_GYM_TV_CHANNEL_BY_ID_SUCCESS';
export const GET_GYM_TV_CHANNEL_BY_ID_FAILED = 'GET_GYM_TV_CHANNEL_BY_ID_FAILED';

export const UPDATE_GYM_TV_CHANNEL_REQUEST = 'UPDATE_GYM_TV_CHANNEL_REQUEST';
export const UPDATE_GYM_TV_CHANNEL_SUCCESS = 'UPDATE_GYM_TV_CHANNEL_SUCCESS';
export const UPDATE_GYM_TV_CHANNEL_FAILED = 'UPDATE_GYM_TV_CHANNEL_FAILED';

export const DELETE_GYM_TV_CHANNEL_REQUEST = 'DELETE_GYM_TV_CHANNEL_REQUEST';
export const DELETE_GYM_TV_CHANNEL_SUCCESS = 'DELETE_GYM_TV_CHANNEL_SUCCESS';
export const DELETE_GYM_TV_CHANNEL_FAILED = 'DELETE_GYM_TV_CHANNEL_REQUEST';

export const ADD_GYM_TV_CHANNEL_ITEM_REQUEST = 'ADD_GYM_TV_CHANNEL_ITEM_REQUEST';
export const ADD_GYM_TV_CHANNEL_ITEM_SUCCESS = 'ADD_GYM_TV_CHANNEL_ITEM_SUCCESS';
export const ADD_GYM_TV_CHANNEL_ITEM_FAILED = 'ADD_GYM_TV_CHANNEL_ITEM_FAILED';

export const UPDATE_GYM_TV_CHANNEL_ITEM_REQUEST = 'UPDATE_GYM_TV_CHANNEL_ITEM_REQUEST';
export const UPDATE_GYM_TV_CHANNEL_ITEM_SUCCESS = 'UPDATE_GYM_TV_CHANNEL_ITEM_SUCCESS';
export const UPDATE_GYM_TV_CHANNEL_ITEM_FAILED = 'UPDATE_GYM_TV_CHANNEL_ITEM_FAILED';

export const DELETE_GYM_TV_CHANNEL_ITEM_REQUEST = 'DELETE_GYM_TV_CHANNEL_ITEM_REQUEST';
export const DELETE_GYM_TV_CHANNEL_ITEM_SUCCESS = 'DELETE_GYM_TV_CHANNEL_ITEM_SUCCESS';
export const DELETE_GYM_TV_CHANNEL_ITEM_FAILED = 'DELETE_GYM_TV_CHANNEL_ITEM_FAILED';

export const DUPLICATE_GYM_TV_CHANNEL_REQUEST = 'DUPLICATE_GYM_TV_CHANNEL_REQUEST';
export const DUPLICATE_GYM_TV_CHANNEL_SUCCESS = 'DUPLICATE_GYM_TV_CHANNEL_SUCCESS';
export const DUPLICATE_GYM_TV_CHANNEL_FAILED = 'DUPLICATE_GYM_TV_CHANNEL_FAILED';

export const GET_GYM_TV_CLASSES_BY_ROOM_NUMBER_REQUEST = 'GET_GYM_TV_CLASSES_BY_ROOM_NUMBER_REQUEST';
export const GET_GYM_TV_CLASSES_BY_ROOM_NUMBER_SUCCESS = 'GET_GYM_TV_CLASSES_BY_ROOM_NUMBER_SUCCESS';
export const GET_GYM_TV_CLASSES_BY_ROOM_NUMBER_FAILED = 'GET_GYM_TV_CLASSES_BY_ROOM_NUMBER_FAILED';



// WEBPACK FOOTER //
// ./src/Store/ActionTypes/GymTvActionTypes.js